module.exports = __webpack_public_path__ + "static/media/2_pl.849f2b69.png";